<app-evida-error [showRetryButton]="false" [showLogoutButton]="false" [showCancelButton]="false">
    <h2 class="header-medium" translate="profileAdmin.user.edit.errorHeader"></h2>
    <span class="body-copy" translate="profileAdmin.user.edit.errorBody"></span>
    <div class="back-btn-container flex justify-start">
        <app-evida-button class="back-btn mt-6" [type]="'primary'" (clicked)="goBack()">
            {{ 'profileAdmin.user.edit.errorButton' | translate }}
        </app-evida-button>
    </div>
</app-evida-error>
